import { Divider, Grid, Stack, TextField } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import Select from "react-select";
import AgGridTable from "../utilities/AgGridTable";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import selectCellEditor from "../OKR-performance/editor/SelectCellEditor";

const CreateDocument = forwardRef((props, ref) => {
    const dummyData = [
        { giNumber: "GI-2025634", initialCNTRNo: "UT550", giValue: 1000, blDate: "2023-10-27" },
        { giNumber: "GI-2025635", initialCNTRNo: "UT551", giValue: 40500, blDate: "2023-10-27" },
        { giNumber: "GI-2025636", initialCNTRNo: "UT552", giValue: 3000, blDate: "2023-10-27" }
    ]

    const [rowData, setRowData] = useState([])
    const [successMsg, setSuccessMsg] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [BOEXDisabled, setBOEXDisabled] = useState(true);
    const [docLcData, setDocLcData] = useState({
        totalLcValue: 0,
        letterOfCredit: "",
        company: 0,
        companyName: "",
        docNo: "",
        totalAmount: "",
        listOfOrder: []
    })
    const [totalAmount, setTotalAmount] = useState()
    const [lcNumberOptions, setLcNumberOptions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'invoiceNo', headerName: 'GI Number', minWidth: 100, },
        { field: 'internalContainerNo', headerName: 'INTL Cntr No', minWidth: 100, },
        { field: 'totalAmount', headerName: 'GI Value', minWidth: 100, },
        { field: 'eta', headerName: 'BL Date', minWidth: 100, }
    ])

    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredit}`;
    const DocUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocuments}`;
    const containerPlanUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlan}`;

    useEffect(() => {
        const lcNoList = async () => {
            const list = await OAuthService.getList(lcUrl + '/getAllLcNumbers?status=true');
            if (list?.data) {
                const lcNo = list?.data?.map((val) => {

                    return { label: val, value: val }
                });
                if (lcNo.length > 0) {
                    setLcNumberOptions(lcNo)
                }

            }
        }
        lcNoList()
    }, [])

    const loadGIData = async(companyId) => {
        const gidata = await OAuthService.getList(containerPlanUrl + `/getGiNumbers?customerId=${companyId}`);
        if(gidata?.data){
            setRowData(gidata?.data)
        }
    }

    const handleLcChange = async (data) => {
        if (data.value) {
            const selectedLc = await OAuthService.getList(lcUrl + `/${data.value}`);
            if (selectedLc?.data) {
                setDocLcData(selectedLc?.data);
                if(selectedLc?.data?.company){
                    loadGIData(selectedLc?.data?.company)
                }
            }
        }
    }

    useEffect(() => {
        const loadAmmendData = async () => {
            let id = props.selectedRow[0]?.documentCreditNo
            const selectedLc = await OAuthService.getList(lcUrl + `/${id}`);
            if (selectedLc?.data) {
                const newData = { ...selectedLc?.data, toleranceAmount: 0, dcAmount: 0, totalDCAmount: 0 };
                if(selectedLc?.data?.company){
                    loadGIData(selectedLc?.data?.company)
                }
                setDocLcData(newData);
                // setAmmendDisabled(true)
            }
        }
        loadAmmendData()
    }, [])

    useEffect(() => {
        if (docLcData.docNo) {
            setSaveDisabled(false)
        } else {
            setSaveDisabled(true)
        }
    }, [docLcData])

    useEffect(() => {
        props.checkBOEXDisabled(BOEXDisabled)
    }, [BOEXDisabled])

    useEffect(() => {
        if (docLcData.documentCreditNo && docLcData.docNo && selectedRows.length > 0) {
            setBOEXDisabled(false)
        } else {
            setBOEXDisabled(true)
        }
    }, [docLcData])

    useEffect(() => {
        props.checkSaveDisabled(saveDisabled)
    }, [saveDisabled])

    const handleSubmit = async () => {
        let giData = selectedRows.map((data) => {
            data.giNumber = data?.invoiceNo;
            data.initialCNTRNo = data?.internalContainerNo;
            data.giValue = data?.totalAmount;
            data.blDate = data?.eta;
            return data
        })
        let lcId = (lcUrl + `/${docLcData.id}`);

        let documentObj = { totalAmount, ...docLcData, listOfOrder: giData, letterOfCredit: lcId }

        delete documentObj.accepted
        delete documentObj.active
        delete documentObj.balance
        delete documentObj.bank
        delete documentObj.bankAddress
        delete documentObj.bankIdentifierCode
        delete documentObj.dateOfAmmendment
        delete documentObj.dateOfIssue
        delete documentObj.dcAmount
        delete documentObj.documentCreditNo
        delete documentObj.issuingBankName
        delete documentObj.expiryDate
        delete documentObj.lastDateOfShipment
        delete documentObj.orderType
        delete documentObj.pending
        delete documentObj.reConciled
        delete documentObj.received
        delete documentObj.toleranceAmount
        delete documentObj.toleranceLevel
        delete documentObj.topUpTillDate
        delete documentObj.totalDCAmount
        delete documentObj.totalLcValue
        delete documentObj.utilized
        delete documentObj.usance
        delete documentObj.company
        delete documentObj.companyName
        delete documentObj.createdAt
        delete documentObj.createdBy
        delete documentObj.updatedAt
        delete documentObj.updatedBy
        delete documentObj.id

        try {
            await OAuthService.addData(DocUrl, documentObj);
            setSuccessMsg('LC-Document created successfully.')
            return 'LC-Document created successfully.';

        } catch (error) {

        }
    }

    const onSelectionChanged = (params) => {
        const selected = params?.api?.getSelectedRows();
        const sum = selected?.reduce((total, row) => total + row.totalAmount, 0);
        const firstRow = selected[0];
        const lastRow = selected[selected.length - 1];
        const firstRowInitialCNTRNo = firstRow ? firstRow.internalContainerNo : "";
        const lastRowInitialCNTRNo = lastRow ? lastRow.internalContainerNo : "";
        setSelectedRows(selected);
        setTotalAmount(sum);
        setDocLcData({ ...docLcData, docNo: firstRowInitialCNTRNo + '-' + lastRowInitialCNTRNo })
    }

    const handleDownloadBOEX = async () => {
        let giData = []
        selectedRows.map((data) => {
            giData.push({giNumber: data?.invoiceNo,initialCNTRNo: data?.internalContainerNo, giValue: data?.totalAmount, blDate: data?.eta})
            data.giNumber = data?.invoiceNo;
            data.initialCNTRNo = data?.internalContainerNo;
            data.giValue = data?.totalAmount;
            data.blDate = data?.eta;
            return data
        })
        let documentObj = { totalAmount, listOfOrder: giData, lcNumber: docLcData.documentCreditNo }

        delete documentObj.accepted
        delete documentObj.active
        delete documentObj.balance
        delete documentObj.bank
        delete documentObj.bankAddress
        delete documentObj.bankIdentifierCode
        delete documentObj.dateOfAmmendment
        delete documentObj.dateOfIssue
        delete documentObj.dcAmount
        delete documentObj.documentCreditNo
        delete documentObj.issuingBankName
        delete documentObj.expiryDate
        delete documentObj.lastDateOfShipment
        delete documentObj.orderType
        delete documentObj.pending
        delete documentObj.reConciled
        delete documentObj.received
        delete documentObj.toleranceAmount
        delete documentObj.toleranceLevel
        delete documentObj.topUpTillDate
        delete documentObj.totalDCAmount
        delete documentObj.totalLcValue
        delete documentObj.utilized
        delete documentObj.usance
        delete documentObj.company
        delete documentObj.companyName
        delete documentObj.createdAt
        delete documentObj.createdBy
        delete documentObj.updatedAt
        delete documentObj.updatedBy
        delete documentObj.id
        delete documentObj.transactionId


        const DocPDF = await OAuthService.getPostPdf(lcUrl + '/generateBoiReport', documentObj);
        const file = new Blob([DocPDF?.data], {
            type: 'application/pdf',
        });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL)
    }

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit,
        handleDownloadBOEX: handleDownloadBOEX
    }))
    useEffect(() => {
        if (selectedRows && selectedRows.length === 0) {
            setDocLcData({ ...docLcData, docNo: "" })
        }
    }, [selectedRows])

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    const onGridReady = () => {
    }
    return (
        <>
            <Grid container spacing={2} className="mt-5">

                {(props.selectedRow && props.selectedRow.length > 0) ? <Grid item xs={6}>
                    <Stack>
                        <lable>Documentary Credit No</lable>
                        <TextField
                            value={props.selectedRow[0].documentCreditNo}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                        />
                    </Stack>
                </Grid> :
                    <Grid item xs={6}>
                        <Stack>
                            <lable>Documentary Credit No</lable>
                            <Select
                                name="name"
                                className=" min-w-[150px]"
                                value={(docLcData.letterOfCredit && lcNumberOptions.length > 0) && lcNumberOptions.filter((list) => list.value === docLcData.letterOfCredit)}
                                onChange={handleLcChange}
                                options={lcNumberOptions}
                                styles={customStyles('', '', '0px')}
                            />
                        </Stack>
                    </Grid>
                }
                <Grid item xs={6}>
                    <Stack>
                        <lable>Available Balance</lable>
                        <TextField
                            value={docLcData.totalLcValue}
                            disabled
                            name="tolerance_level"
                            // onChange={handleChangeToleranceLevel}
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Stack>
                </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-8">
                <Grid item xs={8}>
                    <Stack>
                        <lable>Client Name</lable>
                        <TextField
                            value={docLcData.companyName}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        value={docLcData.company}
                        name="customer"
                        disabled
                        inputProps={{
                            sx: { 'padding': '10px' },
                        }}
                        style={{ marginTop: "2rem", width: "100%" }}
                    />
                </Grid>
            </Grid>
            <Grid container className="mt-8" >
                <Grid item xs={12}>
                    <Stack>
                        <lable>Doc No</lable>
                        <TextField
                            value={docLcData.docNo}
                            name="customer"
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                            onChange={(e) => setDocLcData({ ...docLcData, docNo: e.target.value })}

                        />
                    </Stack>
                </Grid>
            </Grid>
            <Divider />
            <div className="mt-8 h-[300px]" >
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    rowSelection={'multiple'}
                    onSelectionChanged={onSelectionChanged}
                />
                <div className="flex justify-end items-baseline mt-8">
                    <label className="mr-8" >Total Selected</label>
                    <TextField
                        name="total"
                        value={totalAmount}
                        disabled
                        inputProps={{
                            sx: { 'width': '80px', 'height': '5px' },
                        }} />
                </div>
            </div>
        </>
    )
})
export default CreateDocument